import { IonContent, IonIcon, IonPage, IonText } from '@ionic/react';
import { home, refresh } from 'ionicons/icons';
import { ReactElement } from 'react';
import i18n from '../../i18n';
import { BaseButton } from '../button/base-button';

/**
 * Error boundary fallback that we provide to Sentry error boundary. This component
 * cannot use hooks (like useTranslation for i18n) otherwise it will fail to render
 * properly
 *
 * @returns
 */
const ErrorBoundaryFallback = (): ReactElement => {
  const reload = () => {
    window.location.reload();
  };

  const goHome = async () => {
    window.location.href = '/?skipLastLocation=true';
  };

  return (
    <IonPage>
      <IonContent>
        <div className="full-height-width content-center">
          <div>
            <IonText>
              <h2>{i18n.t('common:something_went_wrong')}</h2>
            </IonText>
            <div className="content-center">
              <div>
                <BaseButton buttonProps={{ onClick: reload }}>
                  <IonIcon icon={refresh} slot={'start'} />
                  {i18n.t('common:reload')}
                </BaseButton>
                <BaseButton buttonProps={{ onClick: goHome }}>
                  <IonIcon icon={home} slot={'start'} />
                  {i18n.t('common:home')}
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export { ErrorBoundaryFallback };
